import { GraduationCap } from 'lucide-react';
import { lazy } from 'react';
import { msg } from '@/lib/i18n';
import { registerInvalidation } from '@/lib/realtime';
import { registerEntityHref } from '@/ui';
import { registerEntityTab } from '../entityTabs';
import { defineModule } from '../types';
import { coachingKeys } from './api';
import { caseRoute, centerRoute, coachRoute } from './routes';

/**
 * Coaching (server module `coaching`): the Coaching Center workspace (queue, planner proposals,
 * calendar, cases, impact, coaches), the case page, and the driver's Coaching tab.
 */
export const coachingModule = defineModule({
  key: 'coaching',
  routes: [centerRoute, caseRoute, coachRoute],
  nav: [
    {
      key: 'coaching',
      label: msg('Coaching'),
      description: msg('Who needs help?'),
      icon: GraduationCap,
      to: '/coaching',
      section: 'improve',
      order: 50,
      permission: ['coaching.session.read', 'coaching.case.read', 'coaching.priority.read'],
      module: 'coaching',
      match: ['/coaching'],
    },
  ],
  setup() {
    registerEntityTab('driver', {
      key: 'coaching',
      label: msg('Coaching'),
      order: 50,
      permission: ['coaching.priority.read', 'coaching.case.read', 'coaching.session.read'],
      module: 'coaching',
      component: lazy(() => import('./tabs/DriverCoachingTab')),
    });
    registerEntityHref('coaching_case', (id) => `/coaching/cases/${id}`);
    // Coaching events are about a driver (cases, sessions, focus), a case (time) or a user (coach profile).
    registerInvalidation('driver', () => [coachingKeys.all, coachingKeys.me, ['me', 'scores']]);
    registerInvalidation('coaching_case', () => [coachingKeys.all]);
    registerInvalidation('user', () => [
      ['coaching', 'coaches'],
      ['coaching', 'coach-me'],
      ['coaching', 'availability'],
      ['coaching', 'slots'],
    ]);
    registerInvalidation('ai_proposal', () => [coachingKeys.workspace]);
  },
});
